import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1751264736107'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='10264'
    >
        <path
            d='M568 512V329.152H456V512H269.312v109.696H456v182.848h112V621.696h186.688V512H568z m264.32-336.896c-91.84 0-196.352-87.872-313.472-94.4v-0.64c-2.304 0-4.608 0.256-6.848 0.32-2.24-0.064-4.48-0.32-6.784-0.32v0.64c-117.12 6.528-221.76 94.4-313.6 94.4-50.816 0-82.56 139.52-76.48 293.696 4.928-122.048 34.048-219.52 76.48-219.52 91.84 0 196.48-87.872 313.6-94.4v-0.64c2.24 0 4.48 0.256 6.784 0.32 2.24-0.064 4.544-0.32 6.848-0.32v0.64c117.12 6.528 221.632 94.4 313.536 94.4 42.432 0 71.552 97.472 76.416 219.52 6.208-154.24-25.6-293.76-76.416-293.76z m-5.376 669.44c-137.216 130.432-264.32 167.68-307.2 176.768V1024s-2.752-0.32-7.744-1.216c-4.992 0.896-7.68 1.216-7.68 1.216v-2.688c-42.88-9.088-170.048-46.336-307.2-176.768C11.328 668.032 43.52 112.96 150.976 112.96 254.528 112.96 372.288 8.128 504.32 0.64V0c2.56 0 5.12 0.256 7.68 0.384C514.56 0.256 517.12 0 519.68 0v0.704C651.648 8.128 769.472 112.96 872.96 112.96c107.584 0 139.712 555.072-46.08 731.584z'
            p-id='10265'
            fill='currentColor'
        ></path>
    </svg>
)

export const HealthIcon = props => <Icon component={SVG} {...props} />
